var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":_vm.$t('security level'),"dis-hover":""}})}
var staticRenderFns = []

export { render, staticRenderFns }